import React from 'react';
import { motion } from 'framer-motion';
import { useTransition } from '../context/TransitionContext';

const PageWrapper = ({ children }) => {
  const { canRender } = useTransition();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: canRender ? 1 : 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      style={{
        width: '100%',
        visibility: canRender ? 'visible' : 'hidden'
      }}
    >
      {children}
    </motion.div>
  );
};

export default PageWrapper;